import { useGetMerchantProfile } from "../../../../hooks/queries/useMerchantQueries";


const useCompanyDetailsData = () => {
  const {
    data: merchantProfile,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetMerchantProfile();

  return {
    merchantProfile,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export default useCompanyDetailsData;
